import React, { useEffect, useState, RefObject } from "react";
import { Box, Flex, SimpleGrid } from "@chakra-ui/react";
import useGameLiftStreams from "hooks/session/useGameLiftStreams";
import { KeepAlive } from "components";

interface Props {
  sessionId: any;
}

const GameLiftStreamsElement: React.FC<Props> = ({ sessionId }: Props) => {
  const { streamVideoRef, streamAudioRef } = useGameLiftStreams(sessionId);

  console.log("ref from component", streamVideoRef);
  return (
    <Box w="100%" h="auto"
          borderRadius="10px"
         >
      <div id="streamFullscreenOverlay"></div>
      <KeepAlive id={`gameStream-${sessionId}`}>
        <video
          ref={streamVideoRef}
          autoPlay
          playsInline
          disablePictureInPicture
        ></video>
        <audio
          ref={streamAudioRef}
          autoPlay
        />
      </KeepAlive>
    </Box>
  )
}

export default GameLiftStreamsElement;
